import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Box, Button, Typography } from '@mui/material';

const SignaturePad = ({ onSave, onClear, signatureRef }) => {
  return (
    <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 2 }}>
      <Typography variant="body2" gutterBottom>
        Sign below:
      </Typography>
      <Box sx={{
        border: '1px solid #eee',
        bgcolor: '#f9f9f9',
        mb: 1,
        overflow: 'hidden'
      }}>
        <SignatureCanvas
          ref={signatureRef}
          penColor="black"
          canvasProps={{
            width: 500,
            height: 200,
            className: 'signature-canvas',
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={onClear}
        >
          Clear
        </Button>
      </Box>
    </Box>
  );
};

export default SignaturePad;
